import Vue from "vue";
import moment from 'moment-timezone';

Object.defineProperty(Vue.prototype, '$moment', { value: moment });